import { render, staticRenderFns } from "./WorkspaceAreaBottom.vue?vue&type=template&id=4af8edfe&scoped=true&"
import script from "./WorkspaceAreaBottom.vue?vue&type=script&lang=js&"
export * from "./WorkspaceAreaBottom.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceAreaBottom.vue?vue&type=style&index=0&id=4af8edfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af8edfe",
  null
  
)

export default component.exports